import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const InfoCircleIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('InfoCircleIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 16"
    data-track-tag={dataTrackTag}
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 8v3.375m0-5.877v-.03M1.25 8a6.75 6.75 0 1 1 13.5 0 6.75 6.75 0 0 1-13.5 0"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
InfoCircleIcon.id = 'InfoCircleIcon';
InfoCircleIcon.displayName = 'InfoCircleIcon';
export default InfoCircleIcon;
